/**
 * @public
 */
export enum UploadView {
  List = 'list',
  Table = 'Table'
}
